import { branch, compose, renderNothing } from 'recompose';
import TaskList from './taskList';

const enhance = compose(
  branch(({ pending }) => pending, renderNothing),
);

export default enhance(TaskList);
